import { render } from "./serviciosextra.vue?vue&type=template&id=534239d6&scoped=true"
import script from "./serviciosextra.vue?vue&type=script&lang=js"
export * from "./serviciosextra.vue?vue&type=script&lang=js"

import "./serviciosextra.vue?vue&type=style&index=0&id=534239d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534239d6"]])

export default __exports__